import React from 'react';
import './blog-post.css';
import Uberfood from './pictures/Uberfood.jpg';
import Uberaudience from './pictures/Uberaudience.jpg';
import Uberpresent from './pictures/Uberpresent.jpg';
import Uberqna from './pictures/Uberqna.jpg';
import Uberofficer from './pictures/Uberofficer.jpg';
import Uberspeakers from './pictures/Uberspeakers.jpg';
//import reportWebVitals from './reportWebVitals';

const Uber = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Uber Technical Interview Workshop Recap</h2>
                    <p class="site-post-meta">October 10th, 2023</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                     We hosted an Uber Technical Interview Workshop with two women engineers from Uber’s Seattle office
                     and provided Thai food for dinner! WiC members learned about the interview process for software engineering roles 
                     at Uber and tips and advice from the engineers. Students got to learn how to best answer behavioral questions 
                     and how to approach technical interview questions and practiced a sample coding question in groups and 
                     discussed their approaches to the questions with the engineers. Members also had the opportunity to ask the Uber engineers 
                     questions about Uber, internship opportunities, and how to build their technical skills during college! 
                     Thank you so much to everyone who attended - 
                    we hope you learned a lot about technical interviewing and opportunities at Uber!
                    </p>
                    <img src={Uberpresent} alt="Uber speakers starting their presentation"/>
                    <img src={Uberspeakers} alt="Uber speakers presenting"/>
                    <img src={Uberaudience} alt="Members discussing coding problem"/>
                    <img src={Uberqna} alt="Q&A time with Uber speakers"/>
                    <img src={Uberfood} alt="Thai food for dinner"/>
                    <img src={Uberofficer} alt="WiC officer group picture with Uber speakers"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Uber;

